import {Alert, Button, Col, Form, Image, message, Radio, Row, Upload} from 'antd'
import React, {useEffect, useState} from 'react'
import {UploadOutlined} from '@ant-design/icons'
import {uploadTaxPaper} from "../../api/amazonS3";
import {getArtistProfile, patchArtistProfile} from "../../api/artistProfiles";
import HttpError from "../base/HttpError";
import PDFIcon from "../../asset/icons/PDF_file_icon.svg.png"
import Input from "antd/es/input/Input";

const W9 = 'W9'
const W8Ben = 'W8BEN'
const optionW9 = 1
const optionW8Ben = 2

const TaxRadio = (props) => {
    const [value, setValue] = useState(optionW9)
    const [paperUrl, setPaperUrl] = useState(null)
    const [paperTypeValue, setPaperTypeValue] = useState(null)
    useEffect(() => {
        if (props.artistId) {
            getArtistProfile(props.artistId).then((res) => {
                setPaperUrl(res.data?.tax_paper_url)
                if (res.data?.tax_paper_type && res.data?.tax_paper_url) {
                    setPaperTypeValue(res.data.tax_paper_type === W9 ? optionW9 : optionW8Ben)
                    setValue(res.data.tax_paper_type === W9 ? optionW9 : optionW8Ben)
                }
            }).catch(() => {
            })
        }
    }, [props])

    const customRequest = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        const uploadType = value

        function myOnSuccess(ret) {
            const tax_paper_type = uploadType === optionW9 ? W9 : W8Ben
            const url = ret.url
            patchArtistProfile(props.artistId, {
                tax_paper_url: url,
                tax_paper_type: tax_paper_type,
            }).then((r) => {
                onSuccess(ret)
                setPaperTypeValue(uploadType)
                setPaperUrl(url)
                setValue(uploadType)
            }).catch((e) => {
                HttpError(e)
                onError()
            })
        }

        if (props.email && props.artistId) {
            uploadTaxPaper(props.email, file, myOnSuccess, onError, onProgress)
        } else {
            message.error("need select an artist to upload").then(() => {
            })
            onError()
        }
    }

    const onChange = (e) => {
        setValue(e.target.value)
    }

    const getUploadPaper = () => {
        if (paperUrl && paperTypeValue === value) {
            return (
                <Col style={{marginTop: '32px', display: 'flex', gap: 12, marginLeft: '12%'}}>
                    <Alert style={{maxWidth: '800px', padding: '12px'}}
                           message="You have successfully uploaded your tax document" type="success"/>
                    <a href={paperUrl} target={'_blank'} download style={{display: 'block', padding: 4}}>
                        <span style={{paddingRight: 12}}>Download here</span>
                        <Image width={32} height={32} src={PDFIcon} alt={'pdf'}/>
                    </a>
                </Col>
            )
        }
    }

    const displayLayout = () => {
        if (value === optionW9) {
            return (
                <>
                    <Row>
                        <Col span={8}>
                            <b>Update Your W9 Tax Form</b>
                        </Col>
                        <Col span={8}>
                            <a target={'_blank'} href='https://www.irs.gov/pub/irs-pdf/fw9.pdf' download>Download a
                                template</a>
                            <br></br>
                        </Col>
                    </Row>
                    <br></br>
                    <Form.Item
                        name='W9'
                        valuePropName='fileList'
                        getValueFromEvent={(e) => {
                            if (Array.isArray(e)) {
                                return e
                            }
                            return e && e.fileList
                        }}
                    >
                        <Upload listType='text' maxCount={1} customRequest={customRequest}>
                            <Button icon={<UploadOutlined/>}>Click to upload</Button>
                        </Upload>
                    </Form.Item>
                </>
            )
        } else {
            return (
                <>
                    <Row>
                        <Col span={8}>
                            <b>Update Your W8BEN Tax Form</b>
                        </Col>
                        <Col span={8}>
                            <a target={'_blank'} href='https://www.irs.gov/pub/irs-pdf/fw8ben.pdf' download>Download a
                                template</a>
                        </Col>
                        <br></br>
                    </Row>
                    <br></br>
                    <Form.Item
                        name='W8BEN'
                        valuePropName='fileList'
                        getValueFromEvent={(e) => {
                            if (Array.isArray(e)) {
                                return e
                            }
                            return e && e.fileList
                        }}
                    >
                        <Upload listType='text' maxCount={1} customRequest={customRequest}>
                            <Button icon={<UploadOutlined/>}>Click to upload</Button>
                        </Upload>
                    </Form.Item>
                </>
            )
        }
    }

    return (
        <Row>
            <Col span={24}>
                <Form labelCol={{span: 4}}
                      wrapperCol={{span: 16, offset: 1}}
                      colon={false}>
                    <b style={{marginLeft: '12%'}}>Are you currently living in the United States?*</b>
                    <Radio.Group onChange={onChange} value={value} style={{padding: 12}}>
                        <Radio value={1}>Yes</Radio>
                        <Radio value={2}>No</Radio>
                    </Radio.Group>
                    <p></p>
                    <div style={{position: 'relative', marginLeft: '13%'}}>{displayLayout()}</div>
                    <b style={{marginLeft: '12%'}}>Request Sales And Use Tax Certificate of Exemption</b>
                    <Form.Item
                        style={{marginTop: 32}}
                        name='State'
                        label={'State'}
                    >
                        <Input/>
                    </Form.Item>
                </Form>
                {getUploadPaper()}
            </Col>
        </Row>
    )
}
export default TaxRadio
